module.exports = __webpack_public_path__ + "static/si_dlow-ddc7717d0ffa979ef982cdcc5887a3e2.jpg";